import React, { Dispatch, SetStateAction } from 'react'
import Burger from './Burger'
import { ReactComponent as Logo } from '../../../assets/logo_white.svg'
import { SearchModal } from './SearchModal'
import style from './style.module.scss'

type mainHeaderMobile = {
    setActive: Dispatch<SetStateAction<boolean>>

    isSearchOpen: boolean
    toggleSearch: () => void
}

const MainHeaderMobile: React.FC<mainHeaderMobile> = ({
    setActive,
    isSearchOpen,
    toggleSearch,
}) => {
    return (
        <>
            <div className={style.main}>
                <div className={style.top}>
                    <Burger setActive={setActive} />
                    <a href="/" className={style.logo}>
                        <Logo />
                    </a>
                    <button className={style.search} onClick={toggleSearch}>
                        <i className="fi fi-rs-search"></i>
                    </button>
                </div>
            </div>
            <SearchModal isSearchOpen={isSearchOpen} toggleSearch={toggleSearch} />
        </>
    )
}

export default MainHeaderMobile
